import React, { useState, useEffect, useRef } from 'react';
import { Drawer } from '@material-ui/core';
import { Button } from '@material-ui/core';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ComFunction from "../components/ComFunction";
import { useSelector } from "react-redux";
import { DicVal, isEmpty } from '../modules/appLibrary';

import none from '../Resources/washmark/none.jpg';
import w100 from '../Resources/washmark/100.jpg';
import w110 from '../Resources/washmark/110.jpg';
import w111 from '../Resources/washmark/111.jpg';
import w130 from '../Resources/washmark/130.jpg';
import w131 from '../Resources/washmark/131.jpg';
import w132 from '../Resources/washmark/132.jpg';
import w140 from '../Resources/washmark/140.jpg';
import w141 from '../Resources/washmark/141.jpg';
import w142 from '../Resources/washmark/142.jpg';
import w150 from '../Resources/washmark/150.jpg';
import w151 from '../Resources/washmark/151.jpg';
import w200 from '../Resources/washmark/200.jpg';
import w210 from '../Resources/washmark/210.jpg';
import w220 from '../Resources/washmark/220.jpg';
import w300 from '../Resources/washmark/300.jpg';
import w310 from '../Resources/washmark/310.jpg';
import w320 from '../Resources/washmark/320.jpg';
import w410 from '../Resources/washmark/410.jpg';
import w415 from '../Resources/washmark/415.jpg';
import w420 from '../Resources/washmark/420.jpg';
import w425 from '../Resources/washmark/425.jpg';
import w430 from '../Resources/washmark/430.jpg';
import w435 from '../Resources/washmark/435.jpg';
import w440 from '../Resources/washmark/440.jpg';
import w445 from '../Resources/washmark/445.jpg';
import w500 from '../Resources/washmark/500.jpg';
import w510 from '../Resources/washmark/510.jpg';
import w511 from '../Resources/washmark/511.jpg';
import w520 from '../Resources/washmark/520.jpg';
import w530 from '../Resources/washmark/530.jpg';
import w600 from '../Resources/washmark/600.jpg';
import w610 from '../Resources/washmark/610.jpg';
import w611 from '../Resources/washmark/611.jpg';
import w620 from '../Resources/washmark/620.jpg';
import w621 from '../Resources/washmark/621.jpg';
import w700 from '../Resources/washmark/700.jpg';
import w710 from '../Resources/washmark/710.jpg';
import w711 from '../Resources/washmark/711.jpg';
import w712 from '../Resources/washmark/712.jpg';

//---------------------------------------------------------------------
//  WashPicker
//---------------------------------------------------------------------
export default function WashPicker(props) {
    const fnc = useRef();
    const ComFunc = React.forwardRef(ComFunction);

    const washmark = useSelector(state => state.menu.washmark);
    const open = useSelector(state => state.search.washpickeropen);
    const doApply = useSelector(state => state.search.doApply);
    const [show, setshow] = useState(false)
    const [mark1, setmark1] = React.useState('');
    const [mark2, setmark2] = React.useState('');
    const [mark3, setmark3] = React.useState('');
    const [mark4, setmark4] = React.useState('');
    const [mark5, setmark5] = React.useState('');
    const [mark6, setmark6] = React.useState('');
    const [mark7, setmark7] = React.useState('');
    const [marklist1, setmarklist1] = React.useState([]);
    const [marklist2, setmarklist2] = React.useState([]);
    const [marklist3, setmarklist3] = React.useState([]);
    const [marklist4, setmarklist4] = React.useState([]);
    const [marklist5, setmarklist5] = React.useState([]);
    const [marklist6, setmarklist6] = React.useState([]);
    const [marklist7, setmarklist7] = React.useState([]);

    const srcmap = [
        { src: w100, value: "100" },
        { src: w110, value: "110" },
        { src: w111, value: "111" },
        { src: w130, value: "130" },
        { src: w131, value: "131" },
        { src: w132, value: "132" },
        { src: w140, value: "140" },
        { src: w141, value: "141" },
        { src: w142, value: "142" },
        { src: w150, value: "150" },
        { src: w151, value: "151" },
        { src: w200, value: "200" },
        { src: w210, value: "210" },
        { src: w220, value: "220" },
        { src: w300, value: "300" },
        { src: w310, value: "310" },
        { src: w320, value: "320" },
        { src: w410, value: "410" },
        { src: w415, value: "415" },
        { src: w420, value: "420" },
        { src: w425, value: "425" },
        { src: w430, value: "430" },
        { src: w435, value: "435" },
        { src: w440, value: "440" },
        { src: w445, value: "445" },
        { src: w500, value: "500" },
        { src: w510, value: "510" },
        { src: w511, value: "511" },
        { src: w520, value: "520" },
        { src: w530, value: "530" },
        { src: w600, value: "600" },
        { src: w610, value: "610" },
        { src: w611, value: "611" },
        { src: w620, value: "620" },
        { src: w621, value: "621" },
        { src: w700, value: "700" },
        { src: w710, value: "710" },
        { src: w711, value: "711" },
        { src: w712, value: "712" },
    ]

    useEffect(() => {
        if (washmark.length === 0) return;
        let list1 = [];
        let list2 = [];
        let list3 = [];
        let list4 = [];
        let list5 = [];
        let list6 = [];
        let list7 = [];
        let nonecd = "0";
        for (let i = 0; i < washmark.length; i++) {
            let values = washmark[i];
            let key = values[0];
            let src = srcmap.find(e=>e.value === key);
            if (isEmpty(src)) continue;
            if (key === 0) nonecd = values[1];
            if (key >= 100 && key < 200) {
                list1.push({ src: src.src, value: values[1] });
            }
            if (key >= 200 && key < 300) {
                list2.push({ src: src.src, value: values[1] });
            }
            if (key >= 300 && key < 400) {
                list3.push({ src: src.src, value: values[1] });
            }
            if (key >= 400 && key < 500) {
                list4.push({ src: src.src, value: values[1] });
            }
            if (key >= 500 && key < 600) {
                list5.push({ src: src.src, value: values[1] });
            }
            if (key >= 600 && key < 700) {
                list6.push({ src: src.src, value: values[1] });
            }
            if (key >= 700 && key < 800) {
                list7.push({ src: src.src, value: values[1] });
            }
        }
        list1.unshift({ src: none, value: nonecd });
        list2.unshift({ src: none, value: nonecd });
        list3.unshift({ src: none, value: nonecd });
        list4.unshift({ src: none, value: nonecd });
        list5.unshift({ src: none, value: nonecd });
        list6.unshift({ src: none, value: nonecd });
        list7.unshift({ src: none, value: nonecd });
        setmarklist1(list1);
        setmarklist2(list2);
        setmarklist3(list3);
        setmarklist4(list4);
        setmarklist5(list5);
        setmarklist6(list6);
        setmarklist7(list7);
    }, [washmark])

    useEffect(() => {
        setshow(open);
        if (open) {
            setmark1("");
            setmark2("");
            setmark3("");
            setmark4("");
            setmark5("");
            setmark6("");
            setmark7("");
        }
    }, [open])


    function Apply() {
        let data = {
            mark1: mark1,
            mark2: mark2,
            mark3: mark3,
            mark4: mark4,
            mark5: mark5,
            mark6: mark6,
            mark7: mark7,
        };
        doApply(data, 0)
    }

    const handleChange1 = (event, nextView) => {
        setmark1(nextView);
    };
    const handleChange2 = (event, nextView) => {
        setmark2(nextView);
    };
    const handleChange3 = (event, nextView) => {
        setmark3(nextView);
    };
    const handleChange4 = (event, nextView) => {
        setmark4(nextView);
    };
    const handleChange5 = (event, nextView) => {
        setmark5(nextView);
    };
    const handleChange6 = (event, nextView) => {
        setmark6(nextView);
    };
    const handleChange7 = (event, nextView) => {
        setmark7(nextView);
    };

    function onHandleClose() {
        fnc.current.searchlistclose();
    };

    return (
        <div>
            <Drawer anchor={"right"} open={show} onClose={onHandleClose} BackdropProps={{ invisible: true }}>
                <div style={{ marginRight: 10 }}>
                    <div style={{ textAlign: 'left', float: 'left', marginTop: 10, marginLeft: 10 }}>
                        <span >洗濯表示</span>
                    </div>
                    <div style={{ textAlign: 'right', marginTop: 10 }} >
                        <Button variant="outlined" size="small" onClick={Apply}>適用</Button>
                        <Button variant="outlined" size="small" onClick={onHandleClose}>中止</Button>
                    </div>
                </div>
                <div style={{ display: 'flex', width: 600, padding: 20}}>
                    <div>
                        <ToggleButtonGroup
                            orientation="vertical"
                            value={mark1}
                            exclusive
                            onChange={handleChange1}
                        >
                        {marklist1.map(mark => (
                            <ToggleButton value={mark.value}>
                                <img src={mark.src} alt="" style={{ width: 40 }} />
                            </ToggleButton>
                        )) }
                       </ToggleButtonGroup>
                    </div>
                    <div>
                        <ToggleButtonGroup
                            orientation="vertical"
                            value={mark2}
                            exclusive
                            onChange={handleChange2}
                        >
                            {marklist2.map(mark => (
                                <ToggleButton value={mark.value}>
                                    <img src={mark.src} alt="" style={{ width: 40 }} />
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    </div>
                    <div>
                        <ToggleButtonGroup
                            orientation="vertical"
                            value={mark3}
                            exclusive
                            onChange={handleChange3}
                        >
                            {marklist3.map(mark => (
                                <ToggleButton value={mark.value}>
                                    <img src={mark.src} alt="" style={{ width: 40 }} />
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    </div>
                    <div>
                        <ToggleButtonGroup
                            orientation="vertical"
                            value={mark4}
                            exclusive
                            onChange={handleChange4}
                        >
                            {marklist4.map(mark => (
                                <ToggleButton value={mark.value}>
                                    <img src={mark.src} alt="" style={{ width: 40 }} />
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    </div>
                    <div>
                        <ToggleButtonGroup
                            orientation="vertical"
                            value={mark5}
                            exclusive
                            onChange={handleChange5}
                        >
                            {marklist5.map(mark => (
                                <ToggleButton value={mark.value}>
                                    <img src={mark.src} alt="" style={{ width: 40 }} />
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    </div>
                    <div>
                        <ToggleButtonGroup
                            orientation="vertical"
                            value={mark6}
                            exclusive
                            onChange={handleChange6}
                        >
                            {marklist6.map(mark => (
                                <ToggleButton value={mark.value}>
                                    <img src={mark.src} alt="" style={{ width: 40 }} />
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    </div>
                    <div>
                        <ToggleButtonGroup
                            orientation="vertical"
                            value={mark7}
                            exclusive
                            onChange={handleChange7}
                        >
                            {marklist7.map(mark => (
                                <ToggleButton value={mark.value}>
                                    <img src={mark.src} alt="" style={{ width: 40 }} />
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup>
                    </div>
                </div>
            </Drawer>
            <ComFunc ref={fnc} />
        </div>
    );
};
